const BASE = "https://static.prod-images.emergentagent.com/jobs/6a413588-761d-4eb0-86ea-44f21e446652/images";

export const IMAGES = {
  heroDay: `${BASE}/6c797d4f647d454a9a0dbf3c3cd555fe94c111788f8e1bdb962b29f9a5455038.jpeg`,
  heroNight: `${BASE}/8807f44366ae2edb87943624d84b7b6a64813b552ab366274d6e46d581b10469.jpeg`,
  cars: {
    panda: `${BASE}/f624a4764a07ef00fcb03808f645b387f559bcc71007dbc4f81243e15fcbf61c.jpeg`,
    ypsilon: `${BASE}/3e8b79532399a08150bed5c5400fce81f354fad62f50d0fd2bf7c62215f0ac7f.jpeg`,
    500: `${BASE}/9cbf50c70354e9ab27bb3fc3670a22fab4028bf36a5750388f79071191249efe.jpeg`,
    clio: `${BASE}/07b8ad10b9bc6e6436b86b05669a917a5d0aac5ad8254d6ffb949835b79d2906.jpeg`,
    c3: `${BASE}/3eef05921f13c5fc35d7431243907ea26a0abd954b812206de1411f5b18f7db9.jpeg`,
    crossland: `${BASE}/b226aea02fcad11685df393636abadc89fc7e9f1c5459b244a486246c44a3b14.jpeg`,
    mokka: `${BASE}/ae896a6c406201f8c066508964cf5e2b3659f50c0c1e2775e849e057d5edb5c9.jpeg`,
    "500x": `${BASE}/470a9537b5afae4487726639b147637b2b9484e8f9cc2131df22e4241ffba53e.jpeg`,
    twingo: `${BASE}/fcab26a028cec10658297fa407db896f07d2634352655721ef3cb9619189b59e.jpeg`,
    up: `${BASE}/add5b42c62eafa484827bcee3955709014c4d333750ae42b74de29811a09deea.jpeg`,
    citigo: `${BASE}/915318675c49acf09182af74fa3d8ec7795818daf44aace465bc62ddb11206bd.jpeg`,
    fortwo: `${BASE}/d30e3112227e8bc247bfcabcdae6a0a9bf3df3fb9c2aade3a7b465a3f8d016c4.jpeg`,
    punto: `${BASE}/3002dda2a348bfa5601bffa075cd4a2c59965b32022f0850ff1a5251caf99d37.jpeg`,
    micra: `${BASE}/3afa5e2ffbd62e524cafdf10bbffd3647ad97b3e5c49a853e40b6925429a2f97.jpeg`,
    a1: `${BASE}/c4f38384c79dc03693c68c275e7ede0836ea36b612d553d7a79c1e40ae9b2d82.jpeg`,
    tipo: `${BASE}/1907da1f43de135408432e1d3a014a1a838c73e1c642f9f80db60164bb295b31.jpeg`,
    5008: `${BASE}/bcdda881f094d04562ad32693f6c80d4ced29433e5c0c2aa64003cb977033ae5.jpeg`,
    tiguan: `${BASE}/46918e902e641204996a204afabc32d78b2c5b688b283fe790b5fc700e1d1092.jpeg`,
    captur: `${BASE}/efbe11eeaa8c8328a9a54dc35785aed64010cf2c7a7fefa7ef74a40b7ef1833d.jpeg`,
    puma: `${BASE}/c684ad8ec1d3255b06d849cbd6119cff35b6fd2eb782551fd3333415117f1f84.jpeg`,
    classe_a: `${BASE}/464dc5a6f8c10848a21768309c7a21d13f7214712386a5b540d6cd5394b31589.jpeg`,
    classe_b: `${BASE}/2eb7ce26f2844d8a4ba8be5443401a683043a0e6130a76dfbcc9f323953641eb.jpeg`,
  },
};

export const CATEGORY_IMAGES = {
  CITY: IMAGES.cars.panda,
  COMPACT: IMAGES.cars.clio,
  "SUV / CROSSOVER": IMAGES.cars.crossland,
  SPORT: IMAGES.cars["500x"],
  PREMIUM: IMAGES.cars.classe_a,
};

export const PHOTO_STRIP = [
  { name: "Panda", img: "panda" },
  { name: "Ypsilon", img: "ypsilon" },
  { name: "500", img: "500" },
  { name: "Clio", img: "clio" },
  { name: "C3", img: "c3" },
  { name: "Crossland", img: "crossland" },
  { name: "Mokka", img: "mokka" },
  { name: "500X", img: "500x" },
  { name: "Twingo", img: "twingo" },
];

export const LOCATIONS_FALLBACK = [
  { code: "NCE", name: "Napoli Centrale", type: "station", city: "Napoli", default: true, delivery_min: 5, delivery_max: 15 },
  { code: "NAF", name: "Napoli Afragola AV", type: "station", city: "Afragola", delivery_min: 25, delivery_max: 40 },
  { code: "NAP", name: "Aeroporto Capodichino NAP", type: "airport", city: "Napoli", delivery_min: 15, delivery_max: 30 },
  { code: "NMR", name: "Napoli Mergellina", type: "station", city: "Napoli", delivery_min: 10, delivery_max: 20 },
  { code: "NCF", name: "Napoli Campi Flegrei", type: "station", city: "Napoli", delivery_min: 15, delivery_max: 25 },
  { code: "CAS", name: "Caserta", type: "station", city: "Caserta", delivery_min: 45, delivery_max: 60 },
  { code: "SAL", name: "Salerno Centrale", type: "station", city: "Salerno", delivery_min: 60, delivery_max: 90 },
  { code: "AVE", name: "Aversa", type: "station", city: "Aversa", delivery_min: 35, delivery_max: 50 },
  { code: "POZ", name: "Pozzuoli", type: "station", city: "Pozzuoli", delivery_min: 25, delivery_max: 40 },
  { code: "SOR", name: "Sorrento", type: "station", city: "Sorrento", delivery_min: 75, delivery_max: 90 },
];

/** Foto + descrizione editoriale per ogni modello della flotta. */
export const MODEL_META = {
  "Panda Hybrid": { img: "panda", desc: "L'icona di Napoli: city car ibrida compatta e agilissima nel centro storico e nei vicoli." },
  "Ypsilon Hybrid": { img: "ypsilon", desc: "City car elegante a 5 porte, ibrida, perfetta per muoversi con stile tra centro e lungomare." },
  "500 Hybrid": { img: "500", desc: "La city car italiana per eccellenza: compatta, ibrida e piena di charme." },
  "Up!": { img: "up", desc: "Microcar tedesca leggera e affidabile, ideale nel traffico cittadino." },
  Citigo: { img: "citigo", desc: "City car pratica ed economica, facilissima da parcheggiare." },
  ForTwo: { img: "fortwo", desc: "Due posti ultra-compatta: entra in qualsiasi spazio." },
  Punto: { img: "punto", desc: "Compatta spaziosa e robusta, ottima per la città e i primi viaggi." },
  Micra: { img: "micra", desc: "City car giapponese agile, con buon comfort di bordo." },
  Twingo: { img: "twingo", desc: "City car allegra e maneggevole, dal carattere unico." },
  A1: { img: "a1", desc: "Compatta premium Audi: finiture di alto livello e guida raffinata." },
  Clio: { img: "clio", desc: "Compatta francese bestseller, comoda e moderna." },
  Tipo: { img: "tipo", desc: "Berlina compatta spaziosa, perfetta per famiglie e bagagli." },
  "5008": { img: "5008", desc: "SUV familiare fino a 7 posti, enorme capacità di carico e comfort." },
  Tiguan: { img: "tiguan", desc: "SUV medio Volkswagen, solido e comodo sui lunghi viaggi." },
  Crossland: { img: "crossland", desc: "Crossover compatto alto e pratico, con ottima visibilità." },
  Mokka: { img: "mokka", desc: "Crossover moderno dal design audace, facile in città." },
  C3: { img: "c3", desc: "Compatta francese comfortevole, con sospensioni morbide." },
  Captur: { img: "captur", desc: "Crossover compatto family, pratico e colorato." },
  Puma: { img: "puma", desc: "Crossover sportivo Ford: guida divertente e sicura." },
  "500X Sport": { img: "500x", desc: "Crossover sportivo italiano: stile aggressivo e guida su misura." },
  "Classe A": { img: "classe_a", desc: "Premium compatta Mercedes: tecnologia, prestigio e sicurezza." },
  "Classe B": { img: "classe_b", desc: "Monovolume premium Mercedes: spazio famiglia e comfort assoluto." },
};

const group = (category, title, models) => ({
  category,
  title,
  models,
  total: models.reduce((s, m) => s + m.qty, 0),
});

export const FLEET_FALLBACK = [
  group("CITY", "Fiat Panda Hybrid", [
    { brand: "Fiat", model: "Panda Hybrid", years: "2020-2023", qty: 12 },
    { brand: "Lancia", model: "Ypsilon Hybrid", years: "2021-2023", qty: 9 },
    { brand: "Fiat", model: "500 Hybrid", years: "2021-2023", qty: 5 },
    { brand: "Volkswagen", model: "Up!", years: "2019-2022", qty: 1 },
    { brand: "Skoda", model: "Citigo", years: "2019-2021", qty: 1 },
    { brand: "Smart", model: "ForTwo", years: "2019-2021", qty: 1 },
    { brand: "Fiat", model: "Punto", years: "2017-2019", qty: 1 },
    { brand: "Nissan", model: "Micra", years: "2019-2022", qty: 1 },
    { brand: "Renault", model: "Twingo", years: "2019-2022", qty: 1 },
  ]).valueOf(),
  group("COMPACT", "Audi A1 / Renault Clio", [
    { brand: "Audi", model: "A1", years: "2020-2023", qty: 1 },
    { brand: "Renault", model: "Clio", years: "2021-2023", qty: 1 },
    { brand: "Fiat", model: "Tipo", years: "2021-2023", qty: 1 },
    { brand: "Peugeot", model: "5008", years: "2020-2022", qty: 1 },
    { brand: "Volkswagen", model: "Tiguan", years: "2020-2022", qty: 1 },
  ]).valueOf(),
  group("SUV / CROSSOVER", "Opel Crossland / Mokka", [
    { brand: "Opel", model: "Crossland", years: "2021-2023", qty: 1 },
    { brand: "Opel", model: "Mokka", years: "2021-2023", qty: 2 },
    { brand: "Citroen", model: "C3", years: "2021-2023", qty: 2 },
    { brand: "Renault", model: "Captur", years: "2021-2023", qty: 1 },
    { brand: "Ford", model: "Puma", years: "2021-2023", qty: 1 },
    { brand: "Volkswagen", model: "Tiguan", years: "2021-2023", qty: 1 },
  ]).valueOf(),
  group("SPORT", "Fiat 500X Sport", [{ brand: "Fiat", model: "500X Sport", years: "2020-2022", qty: 2 }]).valueOf(),
  group("PREMIUM", "Mercedes Classe A", [
    { brand: "Mercedes-Benz", model: "Classe A", years: "2021-2023", qty: 1 },
    { brand: "Mercedes-Benz", model: "Classe B", years: "2021-2023", qty: 1 },
  ]).valueOf(),
];

const META = {
  CITY: { seats: 5, transmission: "Manuale", fuel: "Benzina / Hybrid", bags: 4, rca: true, tag: "Più richiesta" },
  COMPACT: { seats: 5, transmission: "Manuale", fuel: "Benzina", bags: 4, rca: false, tag: null },
  "SUV / CROSSOVER": { seats: 5, transmission: "Manuale / Auto", fuel: "Diesel / Mild Hybrid", bags: 4, rca: true, tag: null },
  SPORT: { seats: 5, transmission: "Automatico", fuel: "Diesel", bags: 3, rca: true, tag: null },
  PREMIUM: { seats: 5, transmission: "Automatico", fuel: "Benzina", bags: 4, rca: true, tag: null },
};

FLEET_FALLBACK.forEach((c) => Object.assign(c, META[c.category]));
